import { render, staticRenderFns } from "./organizationActions.vue?vue&type=template&id=1b899c77&scoped=true"
import script from "./organizationActions.vue?vue&type=script&lang=js"
export * from "./organizationActions.vue?vue&type=script&lang=js"
import style0 from "./organizationActions.vue?vue&type=style&index=0&id=1b899c77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b899c77",
  null
  
)

export default component.exports